import  { apiRequest } from '../../apiCall'

export const getAdminUsers = (params) => apiRequest('Auth.GetUsersAdmin',{...params})
export const addAdminUsers = (params) => apiRequest('Auth.AddUsersAdmin',{...params})
export const updateAdminUsers = (params) => apiRequest('Auth.UpdateUsersAdmin',{...params})
export const deActiveUsersAdmin = (params) => apiRequest('Auth.DeActiveUsersAdmin',{...params})
export const getAllRoles = (params) => apiRequest('Role.GetAllRoles',{...params})